<template>
  <div class="statement">
    <article>
      <h1 v-if="$route.params.type !== 'stock'">{{ $t(`statement.${$route.params.type}`) }}</h1>
      <section :class="['info-statement-content', `info-statement-content-${$route.params.type}`]" v-html="content" />
    </article>
  </div>
</template>

<script>
// 默认声明配置
import { FOOTER_STATEMENT } from '@/config/project-defult';

export default {
  name: 'statement-info',
  beforeRouteUpdate(to, from, next) {
    // 设置对应的声明显示
    // this.setContent(to.params.type);
    next();
  },
  // data() {
  //   return {
  //     content: '',
  //   };
  // },
  computed: {
    content() {
      try {
        const key = this.$route.params.type;
        if (!FOOTER_STATEMENT[key]) {
          return '';
        }
        return FOOTER_STATEMENT[key][this.$i18n.locale] || FOOTER_STATEMENT[key].zh || '';
      } catch (err) {
        return '';
      }
    },
  },
  methods: {
    // 从配置文件获取对应的声明显示
    setContent(key) {
      if (!FOOTER_STATEMENT[key]) {
        this.content = '';
        return;
      }
      this.content = FOOTER_STATEMENT[key][this.$i18n.locale] || FOOTER_STATEMENT[key].zh || '';
    },
  },
  // created() {
  //   // this.setContent(this.$route.params.type);
  // },
};

</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'

.statement
  @include base-wrap
  overflow: hidden
  article
    min-height: 650px
    padding: 24px 30px
    background-color: #f5f5f5
    margin-top: 20px
    margin-bottom: 14px
    h1
      font-size: 22px
      color: #0f9675
      text-align: center
      margin-bottom: 20px
</style>

<style lang="sass">
  .info-statement-content
    &-careers
      padding-left: 30px
    &-privacy
      strong
        color: #0f9675
      p
        padding-left: 20px
    &-user
      padding: 0
      $size: 12px
      @mixin commit-title
        padding: 20px 0
        display: inline-block
        font-weight: 700
      strong
        @include commit-title
        font-size: $size
      b
        color: #0f9675
        @include commit-title
      ol
        margin-left: 32px
        color: #7a7a7a
        font-size: $size
        li
          list-style: disc
          padding-bottom: 8px
    &-legal
      p
        padding-left: 20px
    &-faq
      padding: 0
      p
        padding-bottom: 8px
      h2
        font-size: 22px
        &:not(:first-child)
          margin-top: 25px
      strong
        color: #0f9675
        font-weight: inherit
    padding: 10px
    font-size: 14px
    &-stock
      h2
        font-size: 22px
      strong
        color: #0f9675
        font-weight: inherit
    p
      line-height: 20px
      color: #7a7a7a
      font-size: 14px
</style>
